/**
 * @desc Yung-提交表单
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(body: defs.basics.ApprovalRequestDto, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/rpc/approval/formSubmit`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
